import { render } from "./StockAdjustmentLog.vue?vue&type=template&id=ee083406&scoped=true"
import script from "./StockAdjustmentLog.vue?vue&type=script&lang=js"
export * from "./StockAdjustmentLog.vue?vue&type=script&lang=js"

import "./StockAdjustmentLog.vue?vue&type=style&index=0&id=ee083406&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee083406"]])

export default __exports__